/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Reference to a playlist
 * @export
 * @interface PlaylistLibraryPlaylistIdentifier
 */
export interface PlaylistLibraryPlaylistIdentifier {
    /**
     * 
     * @type {string}
     * @memberof PlaylistLibraryPlaylistIdentifier
     */
    type: PlaylistLibraryPlaylistIdentifierTypeEnum;
    /**
     * Playlist ID
     * @type {number}
     * @memberof PlaylistLibraryPlaylistIdentifier
     */
    playlistId: number;
}


/**
 * @export
 */
export const PlaylistLibraryPlaylistIdentifierTypeEnum = {
    Playlist: 'playlist'
} as const;
export type PlaylistLibraryPlaylistIdentifierTypeEnum = typeof PlaylistLibraryPlaylistIdentifierTypeEnum[keyof typeof PlaylistLibraryPlaylistIdentifierTypeEnum];


/**
 * Check if a given object implements the PlaylistLibraryPlaylistIdentifier interface.
 */
export function instanceOfPlaylistLibraryPlaylistIdentifier(value: object): value is PlaylistLibraryPlaylistIdentifier {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "playlistId" in value && value["playlistId"] !== undefined;

    return isInstance;
}

export function PlaylistLibraryPlaylistIdentifierFromJSON(json: any): PlaylistLibraryPlaylistIdentifier {
    return PlaylistLibraryPlaylistIdentifierFromJSONTyped(json, false);
}

export function PlaylistLibraryPlaylistIdentifierFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlaylistLibraryPlaylistIdentifier {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'playlistId': json['playlist_id'],
    };
}

export function PlaylistLibraryPlaylistIdentifierToJSON(value?: PlaylistLibraryPlaylistIdentifier | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'playlist_id': value.playlistId,
    };
}

